// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 179 ? "main" : chunkId) + "." + {"23":"7f48a314","179":"161ddf4f"}[chunkId] + ".css";
};